export const loginPage = () =>
  import("./LoginPage").then((m) => ({ Component: m.LoginPage }));
